import React from 'react'

import { Formik } from 'formik'

import { ZariContext } from '_zari/context'

import { Button, Form, Modal } from '_zari/core'

import { TiposCentrosCosto } from 'constants/index'

import * as CentrosCostoService from 'services/centrosCosto.service'

import * as FormGroups from './formGroups'
import { ValidationSchema } from '../_shared/validation'

const NuevoCentroCostoModal = ({ handleClose, show, refreshTreeView, idNodoPadre, nivel, maxLength }) => {
  const __zariContext = React.useContext(ZariContext)

  const formInitialValues = React.useMemo(
    () => ({
      _idNodoPadre: idNodoPadre,
      anoMesFin: '',
      descripcion: '',
      tipo: TiposCentrosCosto.DIRECTO,
      codigo: '',
      nivel: nivel,
      clase9: '',
      descripcionClase9: ''
    }),
    [idNodoPadre, nivel]
  )

  const submitHandler = async data => {
    await CentrosCostoService.nuevoCentroCosto(data)
      .then(() => {
        __zariContext.snack('success', 'El registro se ha creado.')
        refreshTreeView()
        handleClose()
      })
      .catch(({ data: { error } }) => __zariContext.snack('error', error))
  }

  return (
    <Modal show={show} onHide={handleClose} size='sm'>
      <Modal.Header>
        <Modal.Title>NUEVO CENTRO COSTO</Modal.Title>
      </Modal.Header>
      <Formik initialValues={formInitialValues} onSubmit={submitHandler} validationSchema={ValidationSchema}>
        {({ errors, handleSubmit, isSubmitting, touched, values, setFieldValue, setValues }) => (
          <Form>
            <Modal.Body>
              <FormGroups.CodigoFormGroup
                iError={errors.codigo}
                iTouched={touched.codigo}
                fIsSubmitting={isSubmitting}
                maxLength={maxLength}
                idNodoPadre={idNodoPadre}
                nivel={nivel}
              />
              <FormGroups.DescripcionFormGroup iError={errors.descripcion} iTouched={touched.descripcion} fIsSubmitting={isSubmitting} />
              {nivel === 1 && (
                <FormGroups.Clase9FormGroup
                  iDescripcionName='descripcionClase9'
                  iLabel='Clase 9'
                  iName='clase9'
                  iError={errors.clase9}
                  iTouched={touched.clase9}
                  iValue={values.clase9}
                  fIsSubmitting={isSubmitting}
                  values={values}
                  setValues={setValues}
                />
              )}
              {nivel === 2 && (
                <>
                  <FormGroups.TipoFormGroup iValue={values.tipo} fIsSubmitting={isSubmitting} />
                  <FormGroups.AnoMesFinFormGroup iError={errors.anoMesFin} iTouched={touched.anoMesFin} fIsSubmitting={isSubmitting} />
                </>
              )}
            </Modal.Body>
            <Modal.Footer>
              <Button color='secondary' onClick={handleClose}>
                Cancelar
              </Button>
              <Button onClick={handleSubmit}>Crear</Button>
            </Modal.Footer>
          </Form>
        )}
      </Formik>
    </Modal>
  )
}

export default NuevoCentroCostoModal
